import React from 'react';
import { Text, StyleProp, TextStyle } from 'react-native';
import { BaseTextProps } from './BaseText.types';
import { useBaseTextLogic } from './BaseText.logic';
import { SingleBaseText } from './SingleBaseText';

export interface BaseTextComponentProps extends BaseTextProps {
  conversionStyleMap: Record<string, StyleProp<TextStyle>>;
  conversionKeys: { BOLD: string; ITALIC: string };
  useFontHook: (style: StyleProp<TextStyle> | undefined) => StyleProp<TextStyle> | undefined;
}

const BaseText = (props: BaseTextComponentProps) => {
  const { textLines } = useBaseTextLogic(props);
  const { style, testID, useFontHook } = props;

  if (textLines.length > 1) {
    return (
      <Text style={style}>
        {textLines.map(({ text, textStyle }) => {
          const key = `${testID ?? 'text'}-${text}`;
          const singleTextStyle = {
            fontWeight: (style as TextStyle)?.fontWeight,
            fontStyle: (style as TextStyle)?.fontStyle,
            ...((textStyle || {}) as TextStyle),
          };
          return (
            <SingleBaseText {...props} style={singleTextStyle} key={key} testID={key} useFontHook={useFontHook}>
              {text}
            </SingleBaseText>
          );
        })}
      </Text>
    );
  } else {
    const [firstElement] = textLines;
    const { text, textStyle } = firstElement ?? {};
    return (
      <SingleBaseText {...props} style={[style, textStyle]} useFontHook={useFontHook}>
        {text}
      </SingleBaseText>
    );
  }
};

export default BaseText;
